"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Widget", {
  enumerable: true,
  get: function get() {
    return _Widget["default"];
  }
});
Object.defineProperty(exports, "changeMerchant", {
  enumerable: true,
  get: function get() {
    return _commands.changeMerchant;
  }
});
Object.defineProperty(exports, "events", {
  enumerable: true,
  get: function get() {
    return _Widget.events;
  }
});
Object.defineProperty(exports, "getMerchantName", {
  enumerable: true,
  get: function get() {
    return _commands.getMerchantName;
  }
});
Object.defineProperty(exports, "getProfile", {
  enumerable: true,
  get: function get() {
    return _commands.getProfile;
  }
});
Object.defineProperty(exports, "getProfileRequestSuccessAction", {
  enumerable: true,
  get: function get() {
    return _slice.getProfileRequestSuccessAction;
  }
});
Object.defineProperty(exports, "name", {
  enumerable: true,
  get: function get() {
    return _slice.name;
  }
});
Object.defineProperty(exports, "reducer", {
  enumerable: true,
  get: function get() {
    return _slice.reducer;
  }
});
Object.defineProperty(exports, "resetErrorAction", {
  enumerable: true,
  get: function get() {
    return _slice.resetErrorAction;
  }
});
Object.defineProperty(exports, "resetStateAction", {
  enumerable: true,
  get: function get() {
    return _slice.resetStateAction;
  }
});
Object.defineProperty(exports, "selectAvailableMerchants", {
  enumerable: true,
  get: function get() {
    return _slice.selectAvailableMerchants;
  }
});
Object.defineProperty(exports, "selectError", {
  enumerable: true,
  get: function get() {
    return _slice.selectError;
  }
});
Object.defineProperty(exports, "selectInLoadingProcess", {
  enumerable: true,
  get: function get() {
    return _slice.selectInLoadingProcess;
  }
});
Object.defineProperty(exports, "selectInProcess", {
  enumerable: true,
  get: function get() {
    return _slice.selectInProcess;
  }
});
Object.defineProperty(exports, "selectIsAuth", {
  enumerable: true,
  get: function get() {
    return _slice.selectIsAuth;
  }
});
Object.defineProperty(exports, "selectIsLoaded", {
  enumerable: true,
  get: function get() {
    return _slice.selectIsLoaded;
  }
});
Object.defineProperty(exports, "selectProfile", {
  enumerable: true,
  get: function get() {
    return _slice.selectProfile;
  }
});
Object.defineProperty(exports, "selectRedirectTo401", {
  enumerable: true,
  get: function get() {
    return _slice.selectRedirectTo401;
  }
});
Object.defineProperty(exports, "setLoadingProcessAction", {
  enumerable: true,
  get: function get() {
    return _slice.setLoadingProcessAction;
  }
});
Object.defineProperty(exports, "signIn", {
  enumerable: true,
  get: function get() {
    return _commands.signIn;
  }
});
Object.defineProperty(exports, "signOut", {
  enumerable: true,
  get: function get() {
    return _commands.signOut;
  }
});
Object.defineProperty(exports, "updateProfile", {
  enumerable: true,
  get: function get() {
    return _commands.updateProfile;
  }
});

var _Widget = _interopRequireWildcard(require("./Widget"));

var _commands = require("./ducks/commands");

var _slice = require("./ducks/slice");